import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface ICardHeaderBarProps {
  title: ReactNode;
  /** Right-side content, e.g. an <EditButton />. */
  action?: ReactNode;
  /** Shows a small spinner next to the title. */
  loading?: boolean;
  /** The parent card's horizontal / top padding in px, so the bar can stretch edge to edge. */
  cardPaddingX?: number;
  cardPaddingTop?: number;
}

/**
 * Grey title bar for `c-card2` cards, matching the My Business Information cards.
 */
const CardHeaderBar: FC<ICardHeaderBarProps> = ({ title, action, loading = false, cardPaddingX = 15, cardPaddingTop = 10 }) => (
  <Box sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    m: `-${cardPaddingTop}px -${cardPaddingX}px 12px`,
    px: '15px',
    minHeight: 40,
    py: 0.5,
    bgcolor: '#e9ecf1',
    borderBottom: '1px solid #dcdcdc',
    borderRadius: '8px 8px 0 0',
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, margin: 0 }}>{title}</h5>
      {loading ? <CircularProgress size={16} /> : null}
    </Box>
    {action}
  </Box>
);

export default CardHeaderBar;
